import { IAssetMetadata } from "../..";
import { MediaType } from "../../../types";
import { PexelsImageItem } from "../types";
import { BasePexelsAsset } from "./base";

export class ImageAsset extends BasePexelsAsset {
  private item: PexelsImageItem;

  constructor(item: PexelsImageItem) {
    super(item.id, item.url);
    this.item = item;
  }

  getName(): string {
    return this.item.alt || `Pexels Image ${this.item.id}`;
  }

  getMediaType(): MediaType {
    return MediaType.Image;
  }

  getImageUrlForCard(): string {
    return this.item.src.medium;
  }

  getPreviewUrl(): string {
    return this.item.src.large;
  }

  getDownloadUrl(): string {
    return this.item.src.original;
  }

  async downloadFile(): Promise<{ blob: Blob; filename: string }> {
    const response = await fetch(this.item.src.original);
    if (!response.ok) throw new Error(`Failed to download Pexels image: ${response.statusText}`);
    const blob = await response.blob();
    const ext = this.item.src.original.split('.').pop()?.split('?')[0] ?? 'jpg';
    return { blob, filename: `${this.getName()}.${ext}` };
  }

  getMetadata(): IAssetMetadata {
    return {
      status: 'ready',
      date: '',
      size: 0, // Pexels API doesn't provide file size in the search response
      licence: 'Pexels-licence',
      licenceUrl: 'https://www.pexels.com/license/',
      author: this.item.photographer,
      tags: [],
      categories: [],
      dimensions: `${this.item.width} x ${this.item.height}`,
    };
  }
}
